import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import { checkIfPruefAssitenzNeedsToValidate } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

const MarktausblickSkizzeEmob: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<PruefAssistenz
				statusPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0089835347_rhabens_Pruefung_Pruefstatus.path
				}
				hinweisPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0096703458_nweis_Fuer_Den_Antragsteller.path
				}
				ueberarbeitetAmPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0099269789_ns_Pruefung_Ueberarbeitet_Am.path
				}
				erledigtPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0106506068_Vorhabens_Pruefung_Erledigt.path
				}
				formStruc={PruefAssistenzStruc()}
			/>
			<CreateForm
				formStruc={MarktAusblickStruc()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
		</>
	);
};

export default MarktausblickSkizzeEmob;

const PruefAssistenzStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0106506068_Vorhabens_Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const MarktAusblickStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Innovationsgrad_Skizze,
					placeholder:
						'(Darlegung der Innovation und der Alleinstellungsmerkmale; Abgrenzung zu bestehenden Produkten und technischen Lösungen) ',
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucMarktausblickSkizzeEmob = (application: any, _readOnly: boolean) => {
	const result =
		(
			checkIfPruefAssitenzNeedsToValidate(
				application,
				P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0089835347_rhabens_Pruefung_Pruefstatus.path,
				P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0106506068_Vorhabens_Pruefung_Erledigt.path,
			)
		) ?
			concat(PruefAssistenzStruc(), MarktAusblickStruc())
		:	MarktAusblickStruc();
	return result;
};
